// extracted by mini-css-extract-plugin
export default {"container":"Modal_container__R6oZS","subContainer":"Modal_subContainer__zE4cm","header":"Modal_header__iv9Nc","closeButton":"Modal_closeButton__2QQ05"};